import type { ComponentProps } from 'react';
import { cn } from '../lib/cn';

/**
 * Root of a page inside the app frame. Every page has the same width, set by the shell, so title
 * and edges stay in place when switching pages (docs/ui/design-system.md, "Seitenrahmen"). The
 * templates use it; pages without a template start with it.
 */
export function Page({ className, ...props }: ComponentProps<'div'>) {
  return <div className={cn('flex min-w-0 flex-col', className)} {...props} />;
}
